import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
  mergeWebsocketDocuments,
} from '@freelancer/datastore/core';
import { transformCustomBanner } from './custom-banners.transformers';
import type { CustomBannersCollection } from './custom-banners.types';

export function customBannersReducer(
  state: CollectionStateSlice<CustomBannersCollection> = {},
  action: CollectionActions<CustomBannersCollection>,
): CollectionStateSlice<CustomBannersCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'customBanners') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<CustomBannersCollection>(
          state,
          transformIntoDocuments(result.custom_banners, transformCustomBanner),
          order,
          ref,
        );
      }
      return state;
    }

    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'customBanners') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<CustomBannersCollection>(
          state,
          transformIntoDocuments([result.custom_banner], transformCustomBanner),
          ref,
        );
      }
      return state;
    }

    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'customBanners') {
        const { result, ref } = action.payload;
        return mergeWebsocketDocuments<CustomBannersCollection>(
          state,
          transformIntoDocuments([result.custom_banner], transformCustomBanner),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
